import { render } from "./PersonTitle.vue?vue&type=template&id=1f6ff7c2"
import script from "./PersonTitle.vue?vue&type=script&lang=js"
export * from "./PersonTitle.vue?vue&type=script&lang=js"

import exportComponent from "/home/airsxm/domains/airsxm.ridders.dev/public_laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__